var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.4522 41.1623C48.7178 42.1677 50.2953 42.7614 52.0103 42.7614C56.174 42.7614 59.5582 39.2376 59.5582 34.8807C59.5582 30.5238 56.1832 27 52.0103 27C48.8004 27 46.0582 29.0971 44.9668 32.0463",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.2467 48.1121C38.9927 48.1121 42.8401 44.0955 42.8401 39.1408C42.8401 34.186 38.9927 30.1694 34.2467 30.1694C29.5007 30.1694 25.6533 34.186 25.6533 39.1408C25.6533 44.0955 29.5007 48.1121 34.2467 48.1121Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2979 68.1623H18.4451C18.3991 68.1334 18.3439 68.0948 18.2979 68.0562V68.1623Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.6108 58.6923C48.4736 54.3454 45.7405 50.6017 41.9804 48.3133C40.0361 50.458 37.2939 51.7985 34.2491 51.7985C31.2042 51.7985 28.4529 50.4389 26.5178 48.3037C22.7576 50.5921 20.0154 54.3454 18.8874 58.7019C18.5113 60.1573 18.3096 61.6797 18.3096 63.2403V68.066C18.3554 68.1043 18.4013 68.133 18.4563 68.1713C21.8221 70.4788 27.6367 72.0012 34.2582 72.0012C40.8798 72.0012 46.6943 70.4788 50.0602 68.1713H50.2069V68.066V63.2403C50.1977 61.6701 49.996 60.1477 49.6108 58.6923Z",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55.0921 63.7862C59.6043 63.4032 63.4654 62.2063 65.8866 60.5594H66.015V60.4732V56.2315C66.015 54.8622 65.8407 53.5218 65.5014 52.2483C64.5017 48.4278 62.108 45.1436 58.7973 43.1328C57.0914 45.0095 54.6794 46.1873 52.0106 46.1873C50.0846 46.1873 48.2963 45.5649 46.8105 44.5212",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.5532 41.1623C20.2876 42.1677 18.7101 42.7614 16.9951 42.7614C12.8314 42.7614 9.44727 39.2376 9.44727 34.8807C9.44727 30.5238 12.8223 27 16.9951 27C20.205 27 22.9472 29.0971 24.0386 32.0463",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.9137 63.7862C9.40147 63.4032 5.54041 62.2063 3.11923 60.5594H3V60.4732V56.2315C3 54.8622 3.17425 53.5218 3.51358 52.2483C4.51324 48.4278 6.90691 45.1436 10.2177 43.1328C11.9235 45.0095 14.3356 46.1873 17.0044 46.1873C18.9303 46.1873 20.7187 45.5649 22.2044 44.5212",
    stroke: "#EF9071",
    strokeWidth: 1.49802,
    strokeMiterlimit: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.cd1687796b6ccead3275b601effdb835.svg";
export { ForwardRef as ReactComponent };